"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ButtonBase.default;
  }
});

var _ButtonBase = _interopRequireDefault(require("./ButtonBase"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/ButtonBase/index.js
 ** module id = 348
 ** module chunks = 0
 **/